<script setup>
/**
 * This is a general use component that displays a list of appointments.
 * The appointments should be passed in as props, along with a header text.
 */
import { reactive } from 'vue';
import router from '@/router';
import { convertToStringWithCommas } from '@/libraries/HelperFunctions'

const state = reactive({
    appointments: [],
    headerText:'',
})
const props = defineProps(['appointments','headerText']);


init();

async function init() {
    const date = (new Date((new Date).getTime() - 4 * 60 * 60 * 1000)).toISOString().split('T')[0]; //  adjusts for timezone, string splits
    // REPLACE WITH FIREBASE FUNCTION THAT GETS IN ORDER OF SUBMISSION
    state.appointments = props.appointments;
    state.headerText = props.headerText;
}

function openAppointment(apt) {
    router.push({ name: 'appointment', params: { id: apt.uniqueAppointmentId } });
}

</script>
<template>
    <div class="wrapper-class">
        <div class="title">
            <h1>{{state.headerText}}</h1>
        </div>
        <div class="content-box">
            <div v-if="state.appointments.length" class="appointment-entry" v-for="(apt) in state.appointments"
                :key="apt" @click="openAppointment(apt)">
                <div class="cr">{{ apt.cr }}</div>
                <div class="name">{{ apt.patientName }}</div>
                <div class="time">{{ apt.endTime }}</div>
                <div class="codes">{{ convertToStringWithCommas(apt.codes) }}</div>
            </div>
            <div v-else>
                <p>No appointments billed.</p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper-class {
    width: 34rem;
}

.title {
    display: block;
    background-color: #fff;
    padding: 1.25rem;
    border-radius: 1rem;
    text-align: center;
    margin: 1rem 0;
    border: 1px solid #ccc;
    border-top: 5px solid #673ab7;
    // width: 22rem;

    h1 {
        display: inline;
    }
}

.content-box {
    // width: 30rem;
    display: block;
    text-align: center;

    .appointment-entry {
        border: 1px solid #ccc;
        margin: 0.5rem 0rem;
        display: flex;
        padding: 1rem 0;
        border-radius: 5px;

        &:hover {
            background-color: #ebe7f1;
            cursor: pointer;
        }
    }


    .cr,
    .time {
        display: inline-block;
        width: 15%;
    }

    .name,
    .codes {
        display: inline-block;
        width: 30%;
    }
}</style>
